import {
  Button,
  Form,
  Input,
  Select,
  Skeleton,
  Steps
} from "antd";
import { StatusCode } from "common/enums";
import { useWindowSize } from "hooks/useWindowSize.hook";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchTeacherMutation } from "store/services/student/ads.services";
import * as TOPICS_SERVICES from "../../../api/services/topics/topics.services";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";
import Grid from "components/libs/grid";
import CardAdsTeacher from "./components";

//!IMAGES

//!STYLES
import AppResult from "components/appResults";
import { useLocation } from "react-router-dom";
import { setUserConnect } from "store/auth/authSlice";
import { useGetAllLevelsQuery } from "store/services/app/levels.services";
import Pagination from "../../../components/pagination/index";
import s from "../../student/searchTeacher/assets/searchTeacher.module.css";

import SearchIcon from "../../../assets/images/app/search.svg";
import TeacherIcon from "../../../assets/images/teacher/teacher.svg";

const { Option } = Select;
const { Step } = Steps;
const { Search } = Input;

const OrganismeFindStudentTeacher: FC = () => {
  //!HOOKS
  const dispatch = useDispatch();
  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const topics = useSelector((state) => state.topics);
  const { data: levelsData } = useGetAllLevelsQuery();
  const size = useWindowSize();
  const [searchTeacher, { data: teacher, isLoading, isError, isSuccess }] =
    useSearchTeacherMutation();
  const location = useLocation();
  // State to hold the input value
  const [inputValue, setInputValue] = useState('');
  const [formInfos] = Form.useForm();
  const [currentPage, setCurrentPage] = useState<number>(1);

  //!STATE
  const [openDrawerInstaProf, setOpenDrawerInstaProf] =
    useState<boolean>(false);
  const [tempTopic, setTempTopic] = useState<any>();
  const refSubmiteBtn = useRef<any>(null);
  const [top, setTop] = useState(10);
  const [showDrawerCreProf, setShowDrawerCreProf] = useState<boolean>(false);
  const [displayFilter, setDisplayFilter] = useState<boolean>(false);
  const [isBtnInstaProf, setIsBtnInstaProf] = useState<boolean>(false);
  const [idTeacher, setIdTeacher] = useState<any>(null);
  const searchParams = new URLSearchParams(location.search);
  const inputParams = searchParams.get('s');

  const [selectedValue, setSelectedValue] = useState<string>('');

  const [teachersAdded, setTeachersAdded] = useState(user?.listProfs);

  const handleSelectChange = (value: string) => {
    if (value !== undefined) {
      const [minValue, maxValue] = value.split('-');
      const minField = 'minTarif';
      const maxField = 'maxTarif';
      if (maxValue === 'plus') {
        formInfos.setFieldsValue({
          [minField]: parseInt(minValue)
        });
        formInfos.setFieldsValue({
          ['maxTarif']: undefined
        });
      } else {
        formInfos.setFieldsValue({
          [minField]: parseInt(minValue),
          [maxField]: parseInt(maxValue)
        });
      }

      formInfos.setFieldsValue({
        ['tarif']: undefined
      });
      setCurrentPage(1);
      onSubmit();
    }
  };

  const onShowDrawerCalendarProf = () => {
    if (isLoggedIn) {
      setShowDrawerCreProf(true);
    } else {
      dispatch(setUserConnect(true));
    }
  };

  const showDrawerSearchInstaProf = () => {
    if (isLoggedIn) {
      setOpenDrawerInstaProf(!openDrawerInstaProf);
    } else {
      dispatch(setUserConnect(true));
    }
  };

  const OnSelectLevel = useCallback(
    async (levelId: string) => {
      const response = await TOPICS_SERVICES.findAll(levelId);
      if (response?.statusCode === StatusCode.OK) {
        setTempTopic(response?.data);
      }
    },
    [tempTopic]
  );

  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };

  const onSubmit = () => {
    refSubmiteBtn?.current?.click();
  };

  const handleSubmit = (e: any) => {
    handleInputChange(e);
    onSubmit();
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  useEffect(() => {
    if (size.width > 700) {
      setDisplayFilter(true);
    }
  }, [displayFilter, size.width]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const s = searchParams.get('s');

    if (s) {
      setInputValue(s);
      onSubmit();
    }
    else {
      if (isLoggedIn) {
        onSubmit();
      }
      else {
        searchTeacher({ page: currentPage });
      }
    }
  }, [location.search, inputValue]);

  const levels = levelsData?.data;

  useEffect(() => {
    formInfos.setFieldsValue({ page: currentPage });
    onSubmit();
  }, [currentPage]);

  return (
    <React.Fragment>
      <Breadcrumbs isSearchProf={true} />
      <div style={{ maxWidth: "1250px", margin: isMobile ? "20px auto" : "0px auto", padding: isMobile ? "0 4%" : "0 2%" }}>
        {isLoading ? <Skeleton active /> : <div className={s.headerBox}>
          <div className={s.titleBox}>
            <div className={s.titlePictureBox}>
              <img src={TeacherIcon} height={isMobile ? 18 : 45}></img>
            </div>
            Trouver le prof parfait
          </div>
        </div>}

        {isLoading ? <Skeleton active /> : <Form
          layout="inline"
          name="searchTeacher"
          autoComplete="off"
          form={formInfos}
          initialValues={{ search: inputParams, page: currentPage }}
          onFinish={searchTeacher}
        >
          <Button
            htmlType="submit"
            ref={refSubmiteBtn}
            style={{ position: "absolute", left: "-100%" }}
          >
            Go
          </Button>
          <div className={s.searchBox}>
            <div className={s.selectBox}>
              <span style={{ color: "#393E3E", opacity: "0.3", fontSize: isMobile ? "0.75em" : "14px" }}>Choisis ton niveau</span>
              <Form.Item name="level">
                <Select
                  placeholder={<span style={{ color: "#000", opacity: "0.8", fontSize: isMobile ? "0.75em" : "12px" }}>Niveau</span>}
                  allowClear={false}
                  bordered={false}
                  style={{ width: isMobile ? "75vw" : "205px", position: "relative", left: "-12px", top: isMobile ? "-12px" : "0px", fontSize: isMobile ? "0.8em" : "12px" }}
                  onChange={(value: string) => {
                    OnSelectLevel(value);
                    setCurrentPage(1);
                    onSubmit();
                  }}
                >
                  {Object.keys(levels || {}).map((levelGroup) =>
                    levels[levelGroup]?.map((level: any) => (
                      <Option key={level._id} value={level._id}>
                        {level.title}
                      </Option>
                    ))
                  )}
                </Select>
              </Form.Item>
            </div>

            <div className={s.separation}></div>

            <div className={s.selectBox}>
              <span style={{ color: "#393E3E", opacity: "0.3", fontSize: isMobile ? "0.75em" : "14px" }}>Choisis ta matière</span>
              <Form.Item name="matiere">
                <Select
                  placeholder={<span style={{ color: "#000", opacity: "0.8", fontSize: isMobile ? "0.75em" : "12px" }}>Matière</span>}
                  allowClear={false}
                  bordered={false}
                  style={{ width: isMobile ? "75vw" : "205px", position: "relative", left: "-12px", top: isMobile ? "-12px" : "0px", fontSize: isMobile ? "0.8em" : "12px" }}
                  onChange={(value: string) => { setCurrentPage(1); onSubmit(); }}
                >
                  {tempTopic?.map((topic: any) => (
                    <Option key={topic._id} value={topic._id}>
                      {topic.title}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className={s.separation}></div>

            <div className={s.selectBox} style={{ visibility: "hidden" }}>
              <span style={{ color: "#393E3E", opacity: "0.3", fontSize: isMobile ? "0.75em" : "14px" }}>Choisis ton tarif</span>
              <Form.Item name="tarif">
                <Select
                  placeholder={<span style={{ color: "#000", opacity: "0.8", fontSize: isMobile ? "0.75em" : "12px" }}>Tarifs</span>}
                  allowClear
                  bordered={false}
                  style={{ width: isMobile ? "75vw" : "205px", position: "relative", left: "-12px", top: isMobile ? "-12px" : "0px", fontSize: isMobile ? "0.8em" : "12px" }}
                  onChange={handleSelectChange}
                >
                  <Option value={"1-15"}>1 - 15 €</Option>
                  <Option value={"15-30"}>15 - 30 €</Option>
                  <Option value={"30-50"}>30 - 50 €</Option>
                  <Option value={"50-100"}>50 - 100 €</Option>
                  <Option value={"100-plus"}>100 et plus</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={`${s.select}`} style={{ visibility: "hidden", width: "1px" }}>
              <Form.Item name="minTarif">
                <Select
                  placeholder="Tarif min "
                  allowClear
                  bordered={false}
                >
                  <Option value={0}>0</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={`${s.select}`} style={{ visibility: "hidden", width: "1px" }}>
              <Form.Item name="maxTarif">
                <Select
                  placeholder="Tarif max "
                  allowClear
                  bordered={false}
                >
                  <Option value={0}>0</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={s.inputBox}>
              <div className={s.filedSearch}>
                <Form.Item name="search">
                  <Input
                    className={s.searchInput}
                    placeholder="Chercher un prof"
                    bordered={false}
                    style={{ textAlign: "left", paddingTop: isMobile ? "3px" : "10px", paddingLeft: isMobile ? "10px" : "30px", paddingRight: isMobile ? "10px" : "30px" }}
                    onChange={() => { setCurrentPage(1); onSubmit(); }}
                  />
                </Form.Item>
              </div>
              {isMobile && <div style={{ width: "10%" }}>
                <Form.Item>
                  <Button
                    ref={refSubmiteBtn}
                    shape="circle"
                    htmlType="submit"
                    style={{ background: "#8AB0B1", height: "30px", width: "30px" }}
                  >
                    <img src={SearchIcon} height={10} style={{ filter: 'brightness(0) invert(1)' }}></img>
                  </Button>
                </Form.Item>
              </div>}
            </div>
            {!isMobile && <Form.Item>
              <Button
                ref={refSubmiteBtn}
                shape="circle"
                htmlType="submit"
                style={{ background: "#8AB0B1", height: "45px", width: "45px" }}
              >
                <img src={SearchIcon} height={15} style={{ filter: 'brightness(0) invert(1)' }}></img>
              </Button>
            </Form.Item>}
            <Form.Item name="page" hidden><Input value={currentPage}></Input></Form.Item>
            {isLoggedIn && <Form.Item name="userId" initialValue={user?._id} hidden></Form.Item>}
          </div>
        </Form>}

        <div className={s.main}>
          {isLoading && (
            <>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </>
          )}

          {!isLoading && (
            <Grid className={s.grid}>
              {teacher?.data?.result?.map((ad: any, index: number) => (
                ad?.teacher?._id !== "62ceb218ce2dc5e1e1d9be89" && <div key={ad?._id} onClick={() => setIdTeacher(ad)}>
                  <CardAdsTeacher
                    handleDisplayTeacher={() => null}
                    resetDrawerInstaProf={() => null}
                    handleOpenDrwerProfileTeacher={() => null}
                    onShowDrawerCalendarProf={onShowDrawerCalendarProf}
                    ad={ad}
                    isBtnInstaProf={isBtnInstaProf}
                    setIsBtnInstaProf={setIsBtnInstaProf}
                    showDrawerSearchInstaProf={showDrawerSearchInstaProf}
                    teacherAdded={teachersAdded.includes(ad?.teacher?._id) ? true : false}
                  />
                </div>
              ))}
            </Grid>
          )}

          {!isLoading && teacher?.data?.result.length <= 0 && (
            <AppResult status="info" title="Aucun résultat " />
          )}
        </div>
      </div>

      <div style={{ height: "100px", width: "100%" }}></div>

      {!isLoading && teacher?.data?.result.length > 0 && (
        <Pagination
          setCurrentPage={setCurrentPage}
          totalPages={teacher?.data?.totalPages}
          currentPage={currentPage}
        />
      )}
    </React.Fragment>
  );
};

export default OrganismeFindStudentTeacher;
